import { gql } from "@apollo/client";

// Resolves an asset's locations so a declaration (which only knows the assetId)
// can link back to the asset detail page (routed by assetLocationId).
export const AssetActiveLocation = gql`
    query AssetActiveLocation ($assetId: ID!) {
        asset (filter: { id: { equals: $assetId } }) {
            id
            assetLocationList {
                assetLocations {
                    id
                }
            }
        }
    }
`;
